<div class="crux-zipcode"
  [class.crux-zipcode--chubb]="appearance === 'chubb'">
  @if (appearance === 'chubb') {
    <div cbInput [label]="label" [hideRequiredMarker]="hideRequiredMarker">
      <input [formControl]="inputFormControl"
        mask="00000"
        type="tel"
        class="fs-mask"
        [autocomplete]="autoComplete"
        maxlength="5"
        (focusout)="onFocusOut($event)"
        [autofocus]="autofocus" />
    </div>
  }
  @if (appearance !== 'chubb') {
    <mat-form-field
      appearance="fill"
      [floatLabel]="floatLabel"
      [class.legacy]="appearance === 'legacy'"
      [hideRequiredMarker]="hideRequiredMarker">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <input matInput
        [formControl]="inputFormControl"
        mask="00000"
        type="tel"
        class="fs-mask"
        [placeholder]="placeholder"
        [autocomplete]="autoComplete"
        maxlength="5"
        (focusout)="onFocusOut($event)"
        [autofocus]="autofocus" />
    </mat-form-field>
  }

  @if (apiError && showErrors) {
    <mat-error>
      {{apiError}}
    </mat-error>
  }
</div>
